import { c as _c } from "react/compiler-runtime";
import { Badge } from "@website/ui/badge";
import { useTabButton } from "@website/ui/tab-button/tab-button.hook";
import styles from "@website/ui/tab-button/tab-button.module.scss";
import { TabButtonPropertiesType } from "@website/ui/tab-button/tab-button.types";
import { FC } from "react";
export const TabButton: FC<TabButtonPropertiesType> = properties => {
  const $ = _c(31);
  const {
    badge,
    description,
    disabled,
    Wrapper,
    Icon,
    title,
    selected,
    variant: t0,
    color: t1,
    iconPosition: t2,
    behavior: t3,
    size: t4,
    defaultBorder: t5
  } = properties;
  const variant = t0 === undefined ? "contained" : t0;
  const color = t1 === undefined ? "primary" : t1;
  const iconPosition = t2 === undefined ? "top" : t2;
  const behavior = t3 === undefined ? "button" : t3;
  const size = t4 === undefined ? "content" : t4;
  const defaultBorder = t5 === undefined ? false : t5;
  const {
    buttonProperties,
    linkProperties
  } = useTabButton(properties);
  const wrapperClassName = `${styles["tab-button"]} ${styles[variant]} ${styles[size]} ${iconPosition === "side" ? styles["side-icon"] : styles["top-icon"]} ${styles[color]} ${disabled ? styles.disabled : ""} ${selected ? styles.selected : ""} ${defaultBorder ? styles["border-default"] : ""}`;
  let t6;
  if ($[0] !== Icon) {
    t6 = Icon ? <div className={styles["button-icon"]}>{Icon}</div> : null;
    $[0] = Icon;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== title) {
    t7 = <div className={styles["button-title"]}>{title}</div>;
    $[2] = title;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== badge || $[5] !== color) {
    t8 = badge ? <Badge color={color} content={badge} /> : null;
    $[4] = badge;
    $[5] = color;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <div className={styles["button-middle"]}>{t7}{t8}</div>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== description) {
    t10 = description ? <div className={styles["button-description"]}>{description}</div> : null;
    $[10] = description;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t9) {
    t11 = <div className={styles["button-content"]}>{t9}{t10}</div>;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[15] = t11;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const content = t12;
  if (behavior === "link") {
    let t13;
    if ($[18] !== content || $[19] !== linkProperties || $[20] !== wrapperClassName) {
      t13 = <a {...linkProperties} className={wrapperClassName}>{content}</a>;
      $[18] = content;
      $[19] = linkProperties;
      $[20] = wrapperClassName;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    return t13;
  }
  if (behavior === "custom" && Wrapper) {
    let t13;
    if ($[22] !== Wrapper || $[23] !== content || $[24] !== linkProperties || $[25] !== wrapperClassName) {
      t13 = <Wrapper {...linkProperties} className={wrapperClassName}>{content}</Wrapper>;
      $[22] = Wrapper;
      $[23] = content;
      $[24] = linkProperties;
      $[25] = wrapperClassName;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    return t13;
  }
  let t13;
  if ($[27] !== buttonProperties || $[28] !== content || $[29] !== wrapperClassName) {
    t13 = <button {...buttonProperties} className={wrapperClassName}>{content}</button>;
    $[27] = buttonProperties;
    $[28] = content;
    $[29] = wrapperClassName;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};